import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from '@ingka/skeleton';
export default ({ width, height, dataTestId, className, inlineBlock = false }) => (_jsx(Skeleton, { "data-testid": dataTestId, width: width, height: height, inlineBlock: inlineBlock, className: className }));
//# sourceMappingURL=SkapaSkeleton.js.map